import { platformSwitch } from '@certilogo/design-system/dist/configuration';
import native from './native';
import web from './web';

export default platformSwitch({ web, native });
